// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SingleCard_wrapper___rcvg"};